import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ContractsService } from "../../services/contracts.service";
import { ActivatedRoute } from "@angular/router";
import { BsModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { DateUtility } from "../../util/date.utility";
import { AppSettings } from '../../app.settings';
import { StringUtility } from "../../util/string.utility";
import { ValueTransformer } from '../../../../node_modules/@angular/compiler/src/util';
import { AgentUtility } from '../../util';
import { isEmpty } from 'rxjs-compat/operator/isEmpty';
@Component({
    selector: 'app-contract',
    templateUrl: './contract.component.html',
    providers: [ContractsService]
})
export class ContractComponent implements OnInit {

    contractInfo: any;
    preparedPayments:any[];
    @ViewChild('modalContract_l012',{static: false}) modalContract_l012: BsModalComponent;
    @ViewChild('modalContract_l013',{static: false}) modalContract_l013: BsModalComponent;
    @ViewChild('modalContract_l014',{static: false}) modalContract_l014: BsModalComponent;
    showLoadScreen: boolean;
    AllDone: boolean = false;
    urlPay: string;

    constructor(private Service: ContractsService, private activeRoute: ActivatedRoute, private _location: Location) {
    }

    ngOnInit() {
        var number = this.activeRoute.snapshot.params['number'];
        this.toggleLoadScreen();
        this.Service.getContractFromBorlas(number).subscribe((data) => {
            this.AllDone = data.status != "ERROR";
            if (this.AllDone) {
                this.contractInfo = data.data;
                this.getPreparedPayments();
            } else if (data.code == 1013) {
                this.modalContract_l013.open();
            } else if (data.code == 1012) {
                this.modalContract_l012.open();
            } else if (data.code == 1014) {
                this.modalContract_l014.open();
            }
            this.toggleLoadScreen();
            //this.urlPay = this.getPaymentUrl()
        });
    }

    getPreparedPayments(){
        let preparedPayments:any[] = [];
        let countRequest: any[] = [];
        let sortedPayments:any[] = this.contractInfo.payments.epg_array.sort((payment1, payment2) => {
            let date1 = new Date(payment1.due_date);
            let date2 = new Date(payment2.due_date);
            if (date1 > date2)    return -1;
            else if(date1 < date2) return  1;
            else                      return  0;
        })
        sortedPayments.forEach((value,index) => {
            let payment = this.getPaymentsForDate(value.due_date);
            if(this.viewAllPayments()){
                let paymentDate:Date = new Date(payment.due_date);
                let indexatingStartDate:Date= new Date(this.contractInfo.contract.indexating_info.start_date);
                if(paymentDate <= indexatingStartDate){
                    if(!preparedPayments.filter(dublicate => dublicate.due_date == payment.due_date)[0]){

                        let agent = this.getPaymentUrl(payment.amount  - payment.part_pay_amount);

                        if(agent != null && payment.epg_status_brief === "NEW"){
                            
                            if(!countRequest.filter(dublicate => dublicate.due_date == payment.due_date)[0]){
                                countRequest.push(payment);
                                this.Service.getUrlPayments(JSON.stringify(agent)).subscribe((data) => {
                                    payment.urlPay = data.pay_url;
                                    if(this.isIndexating()){
                                        let agentIndex = this.getPaymentUrl(this.contractInfo.contract.indexating_info.index_dept_amount);
                                        if(agentIndex != null){
                                            this.Service.getUrlPayments(JSON.stringify(agentIndex)).subscribe((data) => {
                                                payment.urlPayIndex = data.pay_url;
                                            });
                                        }
                                    }
                                    preparedPayments.push(payment);
                                    preparedPayments = preparedPayments.sort((payment1, payment2) => {
                                        let date1 = new Date(payment1.due_date);
                                        let date2 = new Date(payment2.due_date);
                                        if (date1 > date2)    return -1;
                                        else if(date1 < date2) return  1;
                                        else                      return  0;
                                    })
                                });
                            }
                        }
                        else {
                            preparedPayments.push(payment);
                        }

                    }
                }
            }
            else{
                let previousPayment = sortedPayments[index+1]
                if(!previousPayment){
                    if(!preparedPayments.filter(dublicate => dublicate.due_date == payment.due_date)[0]){

                        let agent = this.getPaymentUrl(payment.amount  - payment.part_pay_amount);

                        if(agent != null && payment.epg_status_brief === "NEW"){

                            if(!countRequest.filter(dublicate => dublicate.due_date == payment.due_date)[0]){
                                countRequest.push(payment);
                                this.Service.getUrlPayments(JSON.stringify(agent)).subscribe((data) => {
                                    payment.urlPay = data.pay_url;
                                    if(this.isIndexating()){
                                        let agentIndex = this.getPaymentUrl(this.contractInfo.contract.indexating_info.index_dept_amount);
                                        if(agentIndex != null){
                                            this.Service.getUrlPayments(JSON.stringify(agentIndex)).subscribe((data) => {
                                                payment.urlPayIndex = data.pay_url;
                                            });
                                        }
                                    }
                                    preparedPayments.push(payment);
                                    preparedPayments = preparedPayments.sort((payment1, payment2) => {
                                        let date1 = new Date(payment1.due_date);
                                        let date2 = new Date(payment2.due_date);
                                        if (date1 > date2)    return -1;
                                        else if(date1 < date2) return  1;
                                        else                      return  0;
                                    })
                                });
                            }
                        }
                        else {
                            preparedPayments.push(payment);
                        }
                    }
                    return;
                }
                if(previousPayment.epg_status_brief != "NEW"){
                    if(!preparedPayments.filter(dublicate => dublicate.due_date == payment.due_date)[0]){
                        let agent = this.getPaymentUrl(payment.amount  - payment.part_pay_amount);

                        
                        if(agent != null && payment.epg_status_brief === "TO_PAY"){ //TO_PAY
                            console.log(countRequest.filter(dublicate => dublicate.due_date == payment.due_date));
                            if(!countRequest.filter(dublicate => dublicate.due_date == payment.due_date)[0]){
                                countRequest.push(payment);
                                this.Service.getUrlPayments(JSON.stringify(agent)).subscribe((data) => {
                                    payment.urlPay = data.pay_url;
                                    if(this.isIndexating()){
                                        let agentIndex = this.getPaymentUrl(this.contractInfo.contract.indexating_info.index_dept_amount);
                                        if(agentIndex != null){
                                            this.Service.getUrlPayments(JSON.stringify(agentIndex)).subscribe((data) => {
                                                payment.urlPayIndex = data.pay_url;
                                            });
                                        }
                                    }
                                    preparedPayments.push(payment);
                                    preparedPayments = preparedPayments.sort((payment1, payment2) => {
                                        let date1 = new Date(payment1.due_date);
                                        let date2 = new Date(payment2.due_date);
                                        if (date1 > date2)    return -1;
                                        else if(date1 < date2) return  1;
                                        else                      return  0;
                                    })
                                }, (err) => {
                                    preparedPayments.push(payment);
                                    preparedPayments = preparedPayments.sort((payment1, payment2) => {
                                        let date1 = new Date(payment1.due_date);
                                        let date2 = new Date(payment2.due_date);
                                        if (date1 > date2)    return -1;
                                        else if(date1 < date2) return  1;
                                        else                      return  0;
                                    })
                                });
                            }
                        }
                        else if(agent != null && previousPayment.epg_status_brief === "PAID" && payment.epg_status_brief === "NEW"){
                            if(!countRequest.filter(dublicate => dublicate.due_date == payment.due_date)[0]){
                                countRequest.push(payment);
                                this.Service.getUrlPayments(JSON.stringify(agent)).subscribe((data) => {
                                    payment.urlPay = data.pay_url;
                                    if(this.isIndexating()){
                                        let agentIndex = this.getPaymentUrl(this.contractInfo.contract.indexating_info.index_dept_amount);
                                        if(agentIndex != null){
                                            this.Service.getUrlPayments(JSON.stringify(agentIndex)).subscribe((data) => {
                                                payment.urlPayIndex = data.pay_url;
                                            });
                                        }
                                    }
                                    preparedPayments.push(payment);
                                    preparedPayments = preparedPayments.sort((payment1, payment2) => {
                                        let date1 = new Date(payment1.due_date);
                                        let date2 = new Date(payment2.due_date);
                                        if (date1 > date2)    return -1;
                                        else if(date1 < date2) return  1;
                                        else                      return  0;
                                    })
                                });
                            }
                        }
                        else {
                            preparedPayments.push(payment);
                        }
                    }
                }
            }
        })

        this.preparedPayments = preparedPayments;
        if(this.haveToPayPayments() && !this.viewAllPayments())
            this.deleteNewPayment();
    }

    haveToPayPayments():boolean{
        let haveToPayPayments:boolean = false;
        this.preparedPayments.forEach(payment => {
            if(payment.epg_status_brief == "TO_PAY")
                haveToPayPayments = true;
        })
        return haveToPayPayments;
    }

    deleteNewPayment(){
        let newPaymentsIndex = null;
       this.preparedPayments.forEach((value, index) => {
            if(value.epg_status_brief == "NEW")
                newPaymentsIndex = index;
       })
        if(newPaymentsIndex != null)
            this.preparedPayments.splice(newPaymentsIndex,1)
    }

    getPaymentsForDate(date){
        let sortedPaymentsGroup:any[] = this.getPaymentGroupByDate(date);
        let haveNewPayments:boolean = false;
        let haveToPayPayments:boolean = false;
        let firstPayments = sortedPaymentsGroup[0]
        if(sortedPaymentsGroup.length == 1)
            return firstPayments;
        let result = {
            amount: 0,
            due_date: firstPayments.due_date,
            epg_status_brief: "PAID",
            part_pay_amount: 0,
            date_of_payment: firstPayments.date_of_payment
        }
        sortedPaymentsGroup.forEach(value => {
            let newDate = new Date(value.date_of_payment);
            let oldDate = new Date(result.date_of_payment);
            if(newDate > oldDate)
                result.date_of_payment = value.date_of_payment;
            if(value.epg_status_brief == "NEW")
                haveNewPayments = true;
            if(value.epg_status_brief == "TO_PAY")
                haveToPayPayments = true;
            result.amount +=value.amount
            result.part_pay_amount += value.part_pay_amount
        })
        if(haveNewPayments || haveToPayPayments)
            result.date_of_payment = null;
        if(result.amount > result.part_pay_amount){
            if(haveToPayPayments)
                result.epg_status_brief = "TO_PAY";
            else if(haveNewPayments)
                result.epg_status_brief = "NEW";
        }
        return result;
    }

    getPaymentGroupByDate(date):any[]{
        return this.contractInfo.payments.epg_array
        .filter(value => DateUtility.dateCompare(value.due_date, date))
        .sort((payment1, payment2) => {
            let date1 = new Date(payment1.due_date);
            let date2 = new Date(payment2.due_date);
            if (date1 > date2)    return -1;
            else if(date1 < date2) return  1;
            else                      return  0;
        });
    }

    viewAllPayments():boolean{
        let viewAll = false;
        let indexatingInfo = this.contractInfo.contract.indexating_info;
        if(indexatingInfo){
            let start:Date = new Date(indexatingInfo.start_date);
            let now:Date = new Date();
            if(start > now){
                viewAll = true;
            }
        }
        return viewAll;
    }

    closeModal() {
        this._location.back();
    }

    toggleLoadScreen() {
        this.showLoadScreen = !this.showLoadScreen;
    }


    diffDate(end, start): number {
        return DateUtility.diffDateNew(end, start);
    }

    diffDateYearsString(diff:number):string{
        return DateUtility.diffDateYearsString(diff);
    }

    getPaymentUrl(fee:number) {
        let insure = this.contractInfo.contract.insuree_contact_profile
        let IDS = this.contractInfo.contract.ids;
        let currency = this.contractInfo.contract.fund_brief;
        let url = null;

        let user = AgentUtility.getUser();

        let phoneInsured = null;

        if(insure.phone_array.length > 0)
            insure.phone_array.forEach(ell => {
                if(ell.phone_type_brief == 'MOBIL')
                    phoneInsured = ell.phone_number;
            })
        
        let dateStart = new Date(this.contractInfo.contract.confirm_date);
        let dateEnd = new Date(this.contractInfo.contract.end_date);

        
        
        if(fee > 0){
            let agent = {
                "is_agent": true,
                "policy_number": IDS.toString(),
                "policy_start_date": dateStart.getFullYear() + '-' + ('0' + (dateStart.getMonth() + 1)).slice(-2) + '-' + ('0' + dateStart.getDate()).slice(-2),
                "policy_end_date": dateEnd.getFullYear() + '-' + ('0' + (dateEnd.getMonth() + 1)).slice(-2) + '-' + ('0' + dateEnd.getDate()).slice(-2),
                "insured_full_name": insure.name + " " + insure.first_name + " " + insure.middle_name,
                "insured_email": user != null && user.Email ? user.Email : "",
                "insured_phone_number": user != null && user.Mobile ? user.Mobile : "0",
                "payer_ip": "127.0.0.1",
                "payer_is_agreed": false,
                "payer_full_name": user.Name + " " + user.FirstName + " " + user.MiddleName,//this.contractInfo.contract.agent_info.name,
                "payer_return_url": "https://ag.renlife.com/",
                "fee": fee,
                "currency": currency,
                "is_3d_secure_enabled": true,
                "metadata": {"external_system_brief":"AGENT_PERSONAL_PROFILE"}
            }

            return agent;

            // this.Service.getUrlPayments(JSON.stringify(agent)).subscribe((data) => {
            //     url = data.pay_url;
            //     return url
            // });
        }
        else
            return null;
        // console.log(url);
        // return StringUtility.getNewPaymentURL(IDS, fee
        // , insure.name, insure.first_name, insure.middle_name
        // , currency)
    }

    isPhone(): boolean {
        try{
            if(this.contractInfo.contract.insuree_contact_profile.phone_array != undefined)
            if(this.contractInfo.contract.insuree_contact_profile.phone_array.length > 0)
                return true;
            return false;
        }
        catch(e){
            return false;
        }
    }

    getPhone(): string {
        let phonesArray:string[] = [];
        this.contractInfo.contract.insuree_contact_profile.phone_array.forEach(element => {
            phonesArray.push(this.filterPhoneView(element.phone_number))
        });
        return phonesArray.join(", ");
    }

    isEmail(): boolean {
        try{
            if(this.contractInfo.contract.insuree_contact_profile.email_array != undefined)
            if(this.contractInfo.contract.insuree_contact_profile.email_array.length > 0)
                return true;
            return false;
        }
        catch(e){
            return false;
        }
    }

    getEmail(): string {
        let emailsArray:string[] = [];
        if(this.contractInfo.contract.insuree_contact_profile.email_array.length > 0){

            this.contractInfo.contract.insuree_contact_profile.email_array.forEach(element => {
                emailsArray.push(element.email)
            });

            return emailsArray.join(", ");
        }
        else
            return "";
    }

    isBirthdayHolder() {
        try{
            return this.contractInfo.contract.insuree_contact_profile.date_of_birth != undefined;
        }
        catch(e){
            return false;
        }
    }

    getBithdayHolder() {
        //var date = new Date(this.contractInfo.info.PolicyHolderBirthDate);
        //var userTimezoneOffset = date.getTimezoneOffset() * 60000;

        return this.contractInfo.contract.insuree_contact_profile.date_of_birth;
    }


    isIndexating():boolean{
        let isIndexating:boolean = false
        let indexatingInfo = this.contractInfo.contract.indexating_info;
        if(indexatingInfo){
            let start:Date = new Date(indexatingInfo.start_date);
            let now:Date = new Date();
            now.setHours(0,0,0,0);
            if(start < now)
                return false;
            let paymentTerm = this.contractInfo.contract.payment_term
            if(paymentTerm == "Ежемесячно"){
                if( DateUtility.leftLessOneMonth(now, start)){
                    isIndexating = true;
                }
            }
            else{
                isIndexating = true;
            }
        }

        return isIndexating;
    }

    getIndexingAmount(headerId:number, description:string):number{
        let assuredCover = this.getAssuredCover(headerId,description);
        return assuredCover? assuredCover.ins_amount : null;
    }

    getIndexingFee(headerId:number, description:string):number{
        let assuredCover = this.getAssuredCover(headerId,description);
        return assuredCover? assuredCover.fee : null;
    }

    getAssuredCover(headerId:number, description:string){
        let indexatingInfo = this.contractInfo.contract.indexating_info;
        let assuredArray:any[] = indexatingInfo.assured_array;
        let assured =  assuredArray.filter((value, index) => {
            return value.p_asset_header_id == headerId
        })[0];
        let assuredCoverArray:any[] = assured.assured_cover_array;
        return assuredCoverArray.filter((value, index) =>{
            return value.description == description
        })[0];
    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }
}
